module.exports = __webpack_public_path__ + "img/like.33bce3a6.svg";